module.exports = __webpack_public_path__ + "img/product_14.a7a4867.svg";